import Joi from '@hapi/joi'

export const groupSchemaObject = {
    groupCode: Joi.string().required().invalid("00").min(2).max(2).label("Group Code").regex(/^\w+(?:\s+\w+)*$/).messages({
        "string.empty": `Group Code required`,
        "string.pattern.base": `Group Code cannot have invalid characters`,
        "string.min": `Please enter {#limit} digit number`,
        "string.max": `Please enter {#limit} digit number`,
        "any.invalid": `Cannot have 00 as group code`
    }),
    groupName: Joi.string().required().label("Group Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Group Name required`,
        "string.pattern.base": `Please enter valid group Name`,
    }),
    isActive: Joi.boolean().label("Active")
}